import * as PropTypes from 'prop-types'

export default {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  variant: PropTypes.oneOf(['normal', 'success']),
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  meta: PropTypes.object,
  input: PropTypes.object,
  flush: PropTypes.bool,
  placeholder: PropTypes.string,
}
